import { render, staticRenderFns } from "./EshopsList.vue?vue&type=template&id=27c8b645&scoped=true"
import script from "./EshopsList.vue?vue&type=script&lang=js"
export * from "./EshopsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c8b645",
  null
  
)

export default component.exports